import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDirectusClient } from "../../lib/directus";
import { readItems } from "@directus/sdk";

// Async thunk para obtener préstamos del usuario
export const fetchUserLoans = createAsyncThunk(
  "prestamos/fetchUserLoans",
  async (userId) => {
    try {
      const directus = await getDirectusClient();
      
      const response = await directus.request(
        readItems("prestamos", {
          fields: [
            "*",
            "vendedor.id",
            "vendedor.first_name",
            "vendedor.last_name",
            "seriales.seriales_id.*",
            "seriales.seriales_id.producto.*",
            "seriales.seriales_id.producto.grupo.*",
            "inventario_nsp.inventario_ns_prestamo_id.id",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.nombre",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.id",
            "inventario_nsp.inventario_ns_prestamo_id.estado",
            "inventario_nsp.inventario_ns_prestamo_id.cantidad"
          ],
          filter: {
            _and: [
              {
                vendedor: {
                  _eq: userId
                }
              },
              {
                estado: {
                  _eq: "activo"
                }
              }
            ]
          },
          sort: ["-date_created"]
        })
      );
      
      return response;
    } catch (error) {
      console.error("Error fetching user loans:", error);
      throw error;
    }
  }
);

const prestamoSlice = createSlice({
  name: "prestamos",
  initialState: {
    userLoans: [],
    loading: false,
    error: null
  },
  reducers: {
    clearUserLoans: (state) => {
      state.userLoans = [];
      state.loading = false;
      state.error = null;
    },
    updateLoanStatus: (state, action) => {
      const { loanId, newStatus } = action.payload;
      const loanIndex = state.userLoans.findIndex(loan => loan.id === loanId);
      if (loanIndex !== -1) {
        state.userLoans[loanIndex].estado = newStatus;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserLoans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserLoans.fulfilled, (state, action) => {
        state.loading = false;
        state.userLoans = action.payload;
        state.error = null;
      })
      .addCase(fetchUserLoans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearUserLoans, updateLoanStatus } = prestamoSlice.actions;
export default prestamoSlice.reducer;
